import { createSelector } from '@ngrx/store';

export const selectGeneralState = (state: any) => state.general;

export const selectDataByKey = (key: string) => createSelector(
    selectGeneralState,
    (state: any) => state.data ? state.data[key] : undefined
);

export const selectDataByKeyOrDefault = (key: string) => createSelector(
    selectGeneralState,
    (state: any) => {
        const keys = key.split('.');
        let value = state.data;
        console.log('keys:', keys);
        console.log('value:', value);
        for (const k of keys) {
            if (value && k in value) {
                value = value[k];
            } else {
                return -1;
            }
        }
        return value;
    }
);